import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  getEngagementInfo: (body) => {
    return httpApi.postDataViaApi({
      url: api.rewards.getEngagementInfo,
      body
    })
  },
  getDashboardInfo: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.rewards.getDashboardInfo,
      queryParams
    })
  },
  downloadProducts: queryParams => {
    return httpApi.getDataViaApi({
      url: api.rewards.downloadProducts,
      queryParams
    })
  },
  uploadProducts: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.rewards.uploadProducts,
      body
    })
  },
  uploadInvoice: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.rewards.uploadInvoice,
      body
    })
  },
  addScannedProduct: (body, queryParams) => {
    return httpApi.postDataViaApi({
      url: api.rewards.addScannedProduct,
      body,
      queryParams
    })
  },
  scannedProductList: queryParams => {
    return httpApi.getDataViaApi({
      url: api.rewards.scannedProductList,
      queryParams
    })
  },
  getScannedProductDetail: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.rewards.getScannedProductDetail,
      queryParams
    })
  }
}
